import { selectProfileByIdQueryOptions } from "@/features/profile/api/selectProfile";
import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { needsPasswordSetup } from "./inviteAccountSetup";

/** Send first-time invite/signup users to choose a password before onboarding or the app. */
export async function redirectIfNeedsPasswordSetup(
    queryClient: QueryClient | undefined,
    userId: string | undefined
): Promise<void> {
    if (!queryClient || !userId) return;

    const profile = await queryClient.ensureQueryData(selectProfileByIdQueryOptions(userId));
    if (profile && needsPasswordSetup(profile)) {
        throw redirect({ to: "/change-password", search: { source: "confirm-account" } });
    }
}
